import api from 'api/config';

/**
 * Config Service for application configuration and feature flags
 */
export const configService = {
  /**
   * Get feature flags from backend
   * @returns {Promise} Response with feature flags
   */
  getFeatures: async () => {
    try {
      const response = await api.get('/config/features');
      return {
        success: true,
        data: response.data,
      };
    } catch (error) {
      console.error('Failed to get feature flags:', error);
      return {
        success: false,
        error:
          error.response?.data?.error || 'Failed to retrieve feature flags',
        // Return defaults on error so app doesn't break
        data: {
          google_auth: true,
          action_proposals: false,
          web_search: false,
          websocket_chat: false,
          signup: false,
        },
      };
    }
  },

  /**
   * Check if a specific feature is enabled
   * @param {string} featureName - Name of the feature to check
   * @returns {Promise<boolean>} Whether the feature is enabled
   */
  isFeatureEnabled: async (featureName) => {
    try {
      const result = await configService.getFeatures();
      if (result.success && result.data) {
        return result.data[featureName] === true;
      }
      return false;
    } catch (error) {
      console.error(`Failed to check feature ${featureName}:`, error);
      return false;
    }
  },
};

export default configService;
